import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import { PaymentSucceeded } from './components/PaymentSucceeded'
// import ListQrCode from './components/ListQrCode'

const PaymentCallbackPage: React.FC = () => {
  return (
    <Switch>
      <Route exact path='/payment/succeeded'>
        <PaymentSucceeded />
      </Route>
      <Redirect to='/payment/succeeded' />
      <Redirect from='/payment' exact={true} to='/payment/succeeded' />
    </Switch>
  )
}

export default PaymentCallbackPage
